/* @flow */
import type {bookMetaData, bookmarkMetaData} from '../flow/booksync'
import auth from '@/auth/auth'

const baseUrl: string = process.env.VUE_APP_BOOKSYNC_URL + '/api' || ''

export default {
  getUserBooks: async function (accessToken: string): Promise<Array<bookMetaData>> {
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'x-access-token': accessToken
      }
    }

    const response = await fetch(`${baseUrl}/pubs/user`, options)
    if (response.status == 401) {
      auth.authorize()
      throw new Error('authentication required')
    }

    return await response.json()
  },

  async getUserBookmarks (accessToken: string, bookId: string): Promise<bookmarkMetaData> {
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'x-access-token': accessToken
      }
    }

    return await (await fetch(`${baseUrl}/bookmark?book=${bookId}`, options)).json()
  },

  async addUserBookmark (accessToken: string, bookmark: Object): Promise<Object> {
    const options = {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(bookmark),
      headers: {
        'x-access-token': accessToken,
        'Content-Type': 'application/json'
      }
    }

    return (await fetch(`${baseUrl}/bookmark`, options)).json()
  },

  async deleteUserBookmark (accessToken: string, bookmarkId: string): Promise<?string> {
    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'x-access-token': accessToken
      }
    }

    return (await fetch(`${baseUrl}/bookmark/${bookmarkId}`, options)).text()
  },

  async getLastReadPage (accessToken: string, bookId: string): Promise<?string> {
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'x-access-token': accessToken
      }
    }

    let getLastPage = await (await fetch(`${baseUrl}/userdatastore?book=${bookId}&key=last_viewed_page`, options)).json()

    return getLastPage
  },

  addLastReadPage (accessToken: string, page: Object): Promise<?string> {
    const options = {
      method: 'POST',
      body: JSON.stringify(page),
      mode: 'cors',
      headers: {
        'x-access-token': accessToken,
        'Content-Type': 'application/json'
      }
    }

    let addLastPage = fetch(`${baseUrl}/userdatastore`, options)
      .then(res => res.json())

    return addLastPage
  },

  updateLastReadPage (accessToken: string, page: Object, lastReadId: string): Promise<?string> {
    const options = {
      method: 'PUT',
      body: JSON.stringify(page),
      mode: 'cors',
      headers: {
        'x-access-token': accessToken,
        'Content-Type': 'application/json'
      }
    }

    let addLastPage = fetch(`${baseUrl}/userdatastore/${lastReadId}`, options)
      .then(res => res.json())

    return addLastPage
  },

  async getBookAnnotations (accessToken: string, bookId: string): Promise<Array<{}>> {
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'x-access-token': accessToken
      }
    }

    return await (await fetch(`${baseUrl}/annotation?book=${bookId}`, options)).json()
  },

  async addUserAnnotation (accessToken: string, annotation: Object): Promise<Object> {
    const options = {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(annotation),
      headers: {
        'x-access-token': accessToken,
        'Content-Type': 'application/json'
      }
    }

    return (await fetch(`${baseUrl}/annotation`, options)).json()
  },

  async updateUserAnnotation (accessToken: string, annotation: Object, annotationId): Promise<Object> {
    const options = {
      method: 'PUT',
      mode: 'cors',
      body: JSON.stringify(annotation),
      headers: {
        'x-access-token': accessToken,
        'Content-Type': 'application/json'
      }
    }

    return (await fetch(`${baseUrl}/annotation/${annotationId}`, options)).json()
  },


  async deleteUserAnnotation (accessToken: string, annotationId: string): Promise<?string> {
    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'x-access-token': accessToken,
        'Content-Type': 'application/json'
      }
    }

    return (await fetch(`${baseUrl}/annotation/${annotationId}`, options)).text()
  },

}
